<template>
  <div class="recordApplicat" >
    <el-divider content-position="left">申请记录</el-divider>
    <el-collapse style="margin-bottom: 0.2rem;" v-model="activeOpen">
      <el-collapse-item title="高级筛选" name="1">
          <el-row class="mb-20 search-row" :span="24">
            <el-col :span="2"><span>申请时间</span></el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="searchArr.applicat_at"
                size="mini"
                type="date"
                placeholder="选择申请时间">
              </el-date-picker>
            </el-col>
            <el-col :span="2"><span>交接时间</span></el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="searchArr.connect_at"
                size="mini"
                type="date"
                placeholder="选择交接时间">
              </el-date-picker>
            </el-col>
            <el-col :span="2"><span>归档时间</span></el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="searchArr.return_at"
                size="mini"
                type="date"
                placeholder="选择归档时间">
              </el-date-picker>
            </el-col>
            </el-row>

            <el-row :span="24">
            <el-col :span="2"><span>驳回时间</span></el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="searchArr.reject_at"
                size="mini"
                type="date"
                placeholder="选择驳回时间">
              </el-date-picker>
            </el-col>
             <el-col :span="2"><span>申请人</span></el-col>
            <el-col :span="6">
              <!-- <el-select v-model="addData.applicat_uid" multiple placeholder="请选择" size="mini"> -->
               <el-select
                :filterable="true"
                multiple
                collapse-tags
                v-model="searchArr.applicat_uid"
                placeholder="请选择"
                size="mini" clearable>
                <el-option
                  v-for="(item, index) in users"
                  :key="index"
                  :label="item.username"
                  :value="item.id" >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2"><span>申请状态</span></el-col>
            <el-col :span="6">
               <el-select
                :filterable="true"
                collapse-tags
                v-model="searchArr.applicat_status"
                placeholder="请选择"
                size="mini" clearable>
                <el-option :value="1" label="申请中"></el-option>
                <el-option :value="2" label="已交接"></el-option>
                <el-option :value="3" label="已归档"></el-option>
                <el-option :value="4" label="已驳回"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="text-align: center;margin-top: .2rem;width: 100%;" :span="24">
            <el-button type="primary" size="mini" @click="handleASearSub">查询</el-button>
            <el-button type="danger" size="mini" @click="handleASearClear">清除</el-button>
          </el-row>
      </el-collapse-item>
    </el-collapse>
    <el-row  class="mt-50 mb-10">
      <el-col :span="6" class="tr">
        <el-input v-model="search" size="mini" placeholder="关键词：公司名" />
      </el-col>
      <el-col :span="4" :offset="14" class="tr">
        <el-button type="primary" size="mini" @click="handleAdd">申请</el-button>
      </el-col>
    </el-row>

    <div class="middle-table">
    <el-table height="calc(100vh - 316px)" :data="pageData" size="medium" style="width: 100%; margin-top: .2rem" v-cloak>
      <el-table-column label="公司" fixed width="300">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleGetOperate(scope.row.id)">{{scope.row.company_name ? scope.row.company_name : ''}}</el-link>
          <el-tooltip class="item" effect="dark" content="复制" placement="top"><i class="el-icon-document-copy" style="margin-left:0.1rem;cursor:pointer" @click="copySome(scope.row.company_name)"></i></el-tooltip>
        </template>
      </el-table-column>
      <el-table-column v-for="(item, index) in col"
      :key="index"
      :label="item.label"
      :prop="item.prop"
      width="150">
        <template slot-scope="scope">
          <span v-if="item.prop === 'applicat_at'">
              <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>
          <span v-else-if="item.prop === 'connect_at'">
              <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>
          <span v-else-if="item.prop === 'return_at'">
              <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>
          <div v-else>
            <span class="count-style">{{scope.row[item.prop]}}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="search ? pageOption.searchCurrentPage : pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    </div>
    <el-drawer
      title="添加申请"
      :visible.sync="addDrawer"
      direction="rtl"
      :before-close="handleAddBeforeClose"
      size="30%">
        <div class="m-tabs-content">
          <el-row>
            <el-col :span="20">
              <el-select v-model="addData.company_id" filterable remote reserve-keyword placeholder="请输入公司字号筛选公司" size="mini" clearable :remote-method="remoteMethod" :loading="loading">
                <el-option v-for="company in companies"
                :key="company.id"
                :label="company.company_name"
                :value="company.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-select v-model="addData.detail_ids" multiple placeholder="请选择使用的材料，可多选" size="mini">
                <el-option
                  v-for="item in details"
                  :key="item.id"
                  :label="item.record_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-input v-model="addData.use_days" type="input" size="mini" :rows="1" placeholder="请输入使用天数" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-input v-model="addData.use_cause" type="textarea" :rows="3" placeholder="请输入使用原因" />
            </el-col>
          </el-row>
          <el-row class="tr">
            <el-button type="primary" size="mini" @click="handleSave">添 加</el-button>
          </el-row>
        </div>
    </el-drawer>
    <el-drawer
      title=""
      :visible.sync="ContactDrawer"
      direction="rtl"
      size="40%">
      <el-tabs style="padding: 0 0.2rem 0 0.4rem">
        <el-tab-pane label="申请人操作记录">
          <div class="blocka">
            <el-timeline>
              <el-timeline-item  v-for="(OperationRecord, index)  in OperationRecord" :key="index" :timestamp="OperationRecord.created_at" placement="top">
                <el-card>
                  <p>{{OperationRecord.operate}}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
  </div>
</template>

<script>
import DateFormatter from 'common/DateFormatter'
export default {
  name: 'RecordApplicat',
  components: {DateFormatter},
  data () {
    return {
      activeOpen: '',
      search: '',
      searchArr: {
        applicat_at: '',
        connect_at: '',
        return_at: '',
        reject_at: '',
        applicat_uid: ''
      },
      loading: false,
      companies: [],
      recordApplicats: [],
      OperationRecord: [],
      col: [
        {
          label: '当前状态',
          prop: 'status_name'
        },
        {
          label: '申请人',
          prop: 'applicat_username'
        },
        {
          label: '申请时间',
          prop: 'applicat_at'
        },
        {
          label: '档案材料',
          prop: 'detail_ids'
        },
        {
          label: '原因说明',
          prop: 'use_cause'
        },
        {
          label: '使用天数',
          prop: 'use_days'
        },
        {
          label: '交接时间',
          prop: 'connect_at'
        },
        {
          label: '交接人',
          prop: 'connect_username'
        },
        {
          label: '归档时间',
          prop: 'return_at'
        },
        {
          label: '归档人',
          prop: 'return_username'
        },
        {
          label: '驳回时间',
          prop: 'reject_at'
        },
        {
          label: '驳回人',
          prop: 'reject_username'
        }
      ],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1,
        pageSize: 30 // 每页显示条数
      },
      details: [],
      users: [],
      addDrawer: false,
      ContactDrawer: false,
      addData: {
        company_id: null,
        detail_ids: [],
        use_days: '',
        use_cause: ''
      }
    }
  },
  computed: {
    pageData: function () {
      let currentPage = this.search ? this.pageOption.searchCurrentPage : this.pageOption.currentPage
      return this.recordApplicats.filter(data => !this.search || data.company_name.toLowerCase().includes(this.search.toLowerCase())).slice(this.pageOption.pageSize * (currentPage - 1), this.pageOption.pageSize * currentPage)
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search ? this.searchTotal() : this.recordApplicats.length
      this.pageOption.searchCurrentPage = 1
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  methods: {
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    // 复制功能
    copy (data) {
      // 存储传递过来的数据
      let OrderNumber = data
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement('input')
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput)
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select()
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand('Copy')
      // 清空输入框
      newInput.remove()
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    copySome (data) {
      this.copy(data)
    },
    getData (query) {
      this.$axios.post('/api/record/applicat_list', this.searchArr)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.recordApplicats = data.data.list
            this.pageOption.total = this.recordApplicats.length
            this.details = data.data.details
            this.users = data.data.users
          }
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      if (this.search) {
        this.pageOption.searchCurrentPage = val
      } else {
        this.pageOption.currentPage = val
      }
    },
    searchTotal () {
      return this.recordApplicats.filter(data => !this.search || data.company_name.toLowerCase().includes(this.search.toLowerCase())).length
    },
    handleAdd () {
      this.addDrawer = true
    },
    handleAddBeforeClose (done) {
      this.addData.company_id = null
      this.addData.detail_ids = []
      this.addData.use_cause = ''
      done()
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchCompanys(query)
        }, 200)
      } else {
        this.companies = []
      }
    },
    searchCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companies = data.data.companies
          }
        })
    },
    handleSave () {
      if (!this.addData.company_id) {
        this.$message.error('申请公司不能为空！')
        return
      }
      if (this.addData.detail_ids.length === 0) {
        this.$message.error('请选择要申请使用的材料！')
        return
      }
      if (!this.addData.use_cause) {
        this.$message.error('请填写使用原因！')
        return
      }
      this.$axios.post('/api/record/record_applicat', this.addData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getData()
            this.addDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleGetOperate (id) {
      // this.ContactDrawer = true
      // OperationRecord
      this.$axios.get('/api/record/applicat_operate_list/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            console.log(data.data)
            // this.$message.success(data.msg)
            this.OperationRecord = data.data.operate_list
            this.ContactDrawer = true
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleASearSub () {
      this.activeOpen = ''
      this.getData()
    },
    handleASearClear () {
      this.activeOpen = ''
      this.searchArr.applicat_at = ''
      this.searchArr.connect_at = ''
      this.searchArr.return_at = ''
      this.searchArr.reject_at = ''
      this.searchArr.applicat_uid = ''
      this.getData()
    }
  },
  mounted () {
    this.getData();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  [v-cloak]
    display: none
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-collapse
    border-bottom 0
    border-top 0
  .el-collapse >>> .el-collapse-item__header
    color: #4C87FC
    font-weight bold
  .el-collapse >>> .el-collapse-item__arrow
    color: #4C87FC
  .recordApplicat >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .count-style
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    .el-row
      margin-bottom: .4rem
    .el-select
      width: 100%
  .recordApplicat
    marginLeft()
  .tr
    text-align: right
  .mt-10
    margin-top: .2rem
  .search-row .el-col
    margin-bottom: .2rem
  .recordApplicat >>> .el-collapse-item__wrap
    position: fixed
    width: -webkit-fill-available
    z-index: 222 !important
  .page-footer
    position: fixed
    bottom: 0
    left: 0
    height: 80px
    background: #fff
    width: 100%
    z-index: 2
  .pagination-style
    padding-top: 25px
    text-align: right
  .middle-table
    z-index: 1
</style>



// WEBPACK FOOTER //
// src/pages/record_applicat/RecordApplicat.vue